module.exports = __webpack_public_path__ + "img/SKWINKELNetActieSuggestiesA1BD39.b316d388.png";